import { cn } from "@/lib/utils";

interface StatusDotProps {
  status: "online" | "offline" | "warning";
  className?: string;
}

export function StatusDot({ status, className }: StatusDotProps) {
  return (
    <div
      className={cn(
        "rounded-full",
        {
          "bg-green-500 shadow-sm shadow-green-500/50": status === "online",
          "bg-red-500 shadow-sm shadow-red-500/50": status === "offline",
          "bg-yellow-500 shadow-sm shadow-yellow-500/50": status === "warning",
        },
        "h-2 w-2", // Tamaño base que puede ser sobrescrito por className
        className
      )}
    />
  );
} 